export default __webpack_public_path__ + "static/media/logs.2c7fb922.png";